import { useContext, useEffect, useMemo } from 'react';
import { useGlobalQueries } from '@/hooks/use-global-queries';
import { HIDE_CHATBOT_CLASSNAME } from './humany-chatbot';
import { AppContext } from '@/contexts/app-context';

// They _promised_ me these variables could be hardcoded (and I believed them @richard!!)

export const ZendeskChatbot = () => {
    const { pageQuery, getSetting } = useGlobalQueries();
    const zendeskSettings = getSetting('zendesk_settings');
    const { url, language, country } = useContext(AppContext);

    const env = useMemo(() => (url.includes('stage') || url.includes('local') ? 'integration' : 'production'), [url]);

    // No more hardcoded production variables @freddie
    const LANG_FIELD_ID = useMemo(() => {
        return {
            production: zendeskSettings?.zendesk_chatbot_language_field_id ?? '24255383271324',
            integration: '24253367255196',
        };
    }, [zendeskSettings?.zendesk_chatbot_language_field_id]);

    const SOURCE_FIELD_ID = useMemo(() => {
        return {
            production: zendeskSettings?.zendesk_source_field_id ?? '24255302087196',
            integration: '24254360620188',
        };
    }, [zendeskSettings?.zendesk_source_field_id]);

    useEffect(() => {
        if (!zendeskSettings?.zendesk_chatbot_activate || !zendeskSettings?.zendesk_chatbot_apikey) {
            return;
        }

        if (pageQuery?.data?.hide_ai_chatbot) {
            window?.zE?.('messenger', 'close');
            document.body.classList.add(HIDE_CHATBOT_CLASSNAME);
        } else {
            document.body.classList.remove(HIDE_CHATBOT_CLASSNAME);
        }
    }, [pageQuery, zendeskSettings]);

    useEffect(() => {
        const dict = {
            se: 'sweden',
            no: 'norway',
            dk: 'denmark',
            fi: 'finland',
        };
        const tags = window?.HelpCenter?.user?.tags || [];

        tags.push(`customer_country_${dict[country]}`);

        window?.zE?.('messenger:set', 'conversationTags', tags);

        const correctedLanguageCode = language === 'no' ? 'nb' : language;

        const conversationFields = [
            {
                id: LANG_FIELD_ID[env],
                value: `resurs_language_${correctedLanguageCode}`,
            },
            {
                id: SOURCE_FIELD_ID[env],
                value: 'source_website',
            },
        ];
        window?.zE?.('messenger:set', 'conversationFields', conversationFields);
    }, [env, language, country, LANG_FIELD_ID, SOURCE_FIELD_ID]);

    return null;
};
